import { toast, Bounce } from "react-toastify";

/**
 * Shows a network error snackbar with appropriate messaging
 * @param message - The network error message to display
 */
export function showNetworkErrorSnackbar(message: string = "Network error. Please check your connection and try again.") {
  toast.error(
    ({ closeToast: _ }) => (
      <div>
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "8px",
          marginBottom: "4px"
        }}>
          <span style={{ fontSize: "1.2em" }}>🌐</span>
          <strong>Connection Error</strong>
        </div>
        <div style={{ color: "#666" }}>{message}</div>
      </div>
    ),
    {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      transition: Bounce,
    }
  );
}
